class LSIPModal {
	constructor(modalId, dontShowAgainCheckboxId) {
		this.modalId = modalId;
		this.dontShowAgainCheckboxId = dontShowAgainCheckboxId;
		// Use modal-specific localStorage key
		this.localStorageKey = `lsip-modal-skip-${modalId}`;
	}

	shouldSkip() {
		const savedData = localStorage.getItem(this.localStorageKey);
		if (!savedData) {
			return false;
		}

		// Handle legacy format (old 'true' string)
		if (savedData === 'true') {
			// Migrate to new format with 1-day expiration
			const now = Date.now();
			const oneDayInMs = 24 * 60 * 60 * 1000;
			const expirationTime = now + oneDayInMs;
			const data = {
				expires: expirationTime,
				savedAt: now
			};
			localStorage.setItem(this.localStorageKey, JSON.stringify(data));
			return true;
		}

		try {
			const data = JSON.parse(savedData);
			const expirationTime = data.expires;
			const now = Date.now();

			// Check if the setting has expired (more than 1 day old)
			if (now > expirationTime) {
				// Expired, remove it and return false
				localStorage.removeItem(this.localStorageKey);
				return false;
			}

			// Still valid, return true
			return true;
		} catch (e) {
			// If parsing fails, treat as expired/invalid
			localStorage.removeItem(this.localStorageKey);
			return false;
		}
	}

	show(onConfirm, onCancel) {
		// Use a small delay to ensure DOM is ready
		setTimeout(() => {
			const modal = document.getElementById(this.modalId);
			if (!modal) {
				console.warn(`Modal #${this.modalId} not found in DOM`);
				if (onConfirm) onConfirm();
				return;
			}

			const modalButton = modal.querySelector('.btn');
			const modalCloseBtn = modal.querySelector('.modal-close-btn');
			const modalContent = modal.querySelector('.modal-content');
			
			if (!modalButton || !modalCloseBtn || !modalContent) {
				console.warn('Modal elements not found:', {
					button: !!modalButton,
					closeBtn: !!modalCloseBtn,
					content: !!modalContent,
					modal: !!modal
				});
				if (onConfirm) onConfirm();
				return;
			}

			// Ensure modal is visible
			$('body').addClass('modal-active');
			modal.classList.add('show');
			
			// Force a reflow to ensure the show class is applied
			void modal.offsetHeight;

			let isClosed = false;
			let observer = null;

			const closeModal = () => {
				if (isClosed) return;
				isClosed = true;

				this.hide();

				// Clean up event listeners
				if (modalButton) {
					modalButton.removeEventListener('click', handleButtonClick);
				}
				if (modalCloseBtn) {
					modalCloseBtn.removeEventListener('click', handleCloseClick);
				}
				modal.removeEventListener('click', handleBackdropClick);
				if (observer) {
					observer.disconnect();
				}
			};

			const confirmAndClose = () => {
				closeModal();

				// Only save "don't show again" setting when button is clicked
				const dontShowAgain = modal.querySelector(
					`#${this.dontShowAgainCheckboxId}`
				);
				if (dontShowAgain && dontShowAgain.checked) {
					// Save with 1-day expiration timestamp
					const now = Date.now();
					const oneDayInMs = 24 * 60 * 60 * 1000; // 1 day in milliseconds
					const expirationTime = now + oneDayInMs;

					const data = {
						expires: expirationTime,
						savedAt: now
					};

					localStorage.setItem(this.localStorageKey, JSON.stringify(data));
				}

				if (onConfirm) onConfirm();
			};

			const cancelAndClose = () => {
				closeModal();
				if (onCancel) onCancel();
			};

			const handleButtonClick = (e) => {
				e.preventDefault();
				e.stopPropagation();
				confirmAndClose();
			};

			const handleCloseClick = (e) => {
				e.preventDefault();
				e.stopPropagation();
				cancelAndClose();
			};

			// Handle clicking outside modal (on backdrop)
			const handleBackdropClick = (e) => {
				// Only trigger if clicking directly on the modal (backdrop), not on modal-content
				if (e.target === modal && !modalContent.contains(e.target)) {
					cancelAndClose();
				}
			};

			// Watch for when modal is closed by global handler (clicking outside)
			observer = new MutationObserver((mutations) => {
				mutations.forEach((mutation) => {
					if (
						mutation.type === 'attributes' &&
						mutation.attributeName === 'class' &&
						!modal.classList.contains('show') &&
						!isClosed
					) {
						// Modal was closed by global handler, cancel (don't check LSIP)
						cancelAndClose();
					}
				});
			});

			observer.observe(modal, {
				attributes: true,
				attributeFilter: ['class'],
			});

			modalButton.addEventListener('click', handleButtonClick);
			modalCloseBtn.addEventListener('click', handleCloseClick);
			modal.addEventListener('click', handleBackdropClick);
		}, 10);
	}

	hide() {
		const modal = document.getElementById(this.modalId);
		if (modal) {
			$('body').removeClass('modal-active');
			modal.classList.remove('show');
		}
	}
}

export default LSIPModal;

